import { Box, Typography } from "@mui/material";
import { IMessageScheduleQueue } from "../../../App/Typings/MessageText";
import { ISaveDripCampaignCommand } from "../../../App/Typings/Campaigns";

export interface ReviewStepProps {
  campaign: ISaveDripCampaignCommand;
  messages: IMessageScheduleQueue[];
}

export default function ReviewStep({ campaign, messages }: ReviewStepProps) {
  return (
    <>
      <Typography variant="h6">
        Please review your campaign, once created the messages cannot be changed.
      </Typography>
      <Box sx={{ p: 2 }}>
        <Box sx={{ mt: 2 }}>
          <Typography sx={{ fontWeight: 600, display: "inline" }}>Name: </Typography>
          <span>&quot;{campaign.name}&quot;</span>
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography sx={{ fontWeight: 600, display: "inline" }}>Candidates: </Typography>
          <span>{campaign.candidateIds?.length} candidate(s)</span>
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography sx={{ fontWeight: 600 }}>Messages:</Typography>
          <ol>
            {messages.map((m) => (
              <li>{`"${m.title}" sending on ${formatDateTime(m.date.toDate())}`}</li>
            ))}
          </ol>
        </Box>
      </Box>
    </>
  );
}

const formatDateTime = (date: Date) => {
  const twelveHour = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
  const amPm = date.getHours() >= 12 ? "PM" : "AM";
  const minutes = date.getMinutes().toLocaleString("en-US", {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });
  return `on ${date.toLocaleDateString()} at ${twelveHour}:${minutes} ${amPm}`;
};
